<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p>
    Are you absolutely sure you want to delete this content list? This will
    remove all content from the list and is irreversible. Please double check
    that this list is not used anywhere on the website, any pages that currently
    use this list will no longer work.
  </p>
</div>
<p>Type <b>delete</b> below to confirm you wish to delete this content list.</p>
<mat-form-field appearance="outline" class="w-1/4">
  <input
    [(ngModel)]="speedbumpText"
    [ngModelOptions]="{ standalone: true }"
    matInput
    id="speedbump"
  />
</mat-form-field>

<div mat-dialog-actions>
  <div class="flex-1"></div>
  <button mat-button [mat-dialog-close]="null">Cancel</button>
  <button
    mat-flat-button
    color="delete"
    [mat-dialog-close]="speedbumpText"
    [disabled]="speedbumpText.toLowerCase() !== 'delete'"
  >
    Delete
  </button>
</div>
